<template>
  <div class="nextStep">
    <div class="nextStep_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
    </div>
    <div class="nextStep_bottom">
      <p class="text">设置新密码</p>
    </div>
    <van-form class="nextStep_form" @submit="onSubmit">
      <van-field
        class="input_pas"
        v-model="password"
        :type="isOpen ? 'text' : 'password'"
        placeholder="请填写新密码"
        :rules="[{ required: true }]"
      >
        <img
          class="password_img"
          slot="right-icon"
          :src="
            isOpen
              ? require('@/assets/img/login/l_hide.png')
              : require('@/assets/img/login/l_show.png')
          "
          alt=""
          @click="isOpen = !isOpen"
        />
      </van-field>
      <div class="but">
        <van-button
          round
          block
          type="info"
          class="form_btn"
          native-type="submit"
          >确认并登录</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  name: "nextStep",
  data() {
    return {
      password: "",
      phone: "",
      isOpen: false,
    };
  },
  mounted() {
    console.log(this.$router, "this.$router.history");
    this.phone = this.$route.query.phone;
    this.code = this.$route.query.code;
  },
  methods: {
    to() {
      this.$router.go(-1);
    },
    // 提交表单
    async onSubmit() {
      const pasRegExp = new RegExp(
        "^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$"
      );
      if (!pasRegExp.test(this.password)) {
        Toast("请设置新密码（6-16个数字、字母组合）");
      } else {
        let res = await this.$apis.loginServe.repwd({
          mobile: this.phone,
          pwd: this.password,
          validateCode: this.code,
        });
        if (res.resultCode === "200") {
          let obj = {
            requestType: "MOBILE",
          };
          obj.username = this.phone;
          obj.password = this.password;
          let loginRes = await this.$apis.loginServe.login(obj);
          if (loginRes.resultCode === "200") {
            Toast("修改成功");
            sessionStorage.setItem("token", loginRes.data.token);
            sessionStorage.setItem(
              "userInfo",
              JSON.stringify(loginRes.content)
            );
          } else {
            Toast("密码修改成功，请重新登录。");
          }
          this.$router.go(-3);
        } else {
          Toast(res.resultDesc);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  background: #fff;
}
.nextStep {
  width: 100%;
  height: 100%;
  background: #fff;
  .nextStep_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
  }
  .nextStep_bottom {
    width: 84%;
    margin: 0 auto;
    overflow: hidden;
    .text {
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-top: 42px;
    }
  }
  .nextStep_form {
    width: 92%;
    margin: 16px auto;
    .input_pas {
      .password_img {
        width: 15px;
        height: 11px;
      }
    }
    .but {
      width: 92%;
      // margin-top: 24px;
      margin: 24px auto;
      .form_btn {
        height: 40px;
        background: #4a79f1;
        border-radius: 22px;
        .van-button__text {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
